import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import UAParser from 'ua-parser-js'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENTS_SELECT = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    QUERY_IAPCONFIG_REQUEST: null,
    QUERY_IAPCONFIG_SUCCESS: null,
  },
  'PAYMENTS_SELECT'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(token) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          token
        },
        endpoint: 'cgs/cashdesk/u/loadPayMethod',
        requestAction: PAYMENTS_SELECT.INIT_REQUEST,
        successAction: PAYMENTS_SELECT.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function queryIapConfig(token) {
  const OSName = new UAParser().getOS().name
  if (OSName === 'Android' || OSName === 'iOS') {
    return (dispatch) => {
      dispatch(
        callAPI({
          dispatch: dispatch,
          method: 'POST',
          body: {
            reqPlatform: OSName.toUpperCase(),
            token: token,
          },
          endpoint: 'cgs/cashdesk/u/queryIapConfig',
          requestAction: PAYMENTS_SELECT.QUERY_IAPCONFIG_REQUEST,
          successAction: PAYMENTS_SELECT.QUERY_IAPCONFIG_SUCCESS,
          success: function(result) {},
        })
      )
    }
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENTS_SELECT.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_SELECT.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_SELECT.QUERY_IAPCONFIG_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_SELECT.QUERY_IAPCONFIG_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentsSelect',
    reducerMap: {
      paymentsSelectState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
